import { render, staticRenderFns } from "./CardFace.vue?vue&type=template&id=aa5c210a&scoped=true"
import script from "./CardFace.vue?vue&type=script&lang=js"
export * from "./CardFace.vue?vue&type=script&lang=js"
import style0 from "./CardFace.vue?vue&type=style&index=0&id=aa5c210a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5c210a",
  null
  
)

export default component.exports